<div class="emp-notif">
  <div class="menu d-flex mt-2">
    <div class="container pl-0">
      <ngx-datatable
        #table
        class="material shadow-none table-width"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [limit]="5"
        [rows]="filteredList"
        *ngIf="showtable"
      >
        <!-- Application Select Column -->
        <ngx-datatable-column
          [flexGrow]="1.5"
          name="Application"
          prop="appName"
          [width]="10"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <p>{{ row.appName }}</p>
          </ng-template>
        </ngx-datatable-column>
        <!-- Event Column -->
        <ngx-datatable-column
          [flexGrow]="1.5"
          name="Event"
          prop="eventName"
          [width]="10"
        >
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <p>{{ row.eventName }}</p>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column
          [flexGrow]="0.5"
          name="Notification Type"
          [width]="10"
        >
          <ng-template
            let-value="value"
            let-row="row"
            let-rowIndex="rowIndex"
            name="Notification Type"
            ngx-datatable-cell-template
          >
            <div class="align-icon">
              <mat-button-toggle-group
                #group="matButtonToggleGroup"
                [value]="row.selectedType"
                (change)="onTypeChange(row, group.value)"
                multiple="true"
              >
                <mat-button-toggle
                  value="internalType"
                  aria-label="notification"
                  [disabled]="row.notify"
                  (click)="internalChange(row)"
                >
                  <mat-icon>notifications</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle
                  aria-label="mail"
                  value="mailType"
                  [disabled]="row.mail"
                  (click)="mailChange(row)"
                >
                  <mat-icon>mail</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle
                  aria-label="message"
                  value="messageType"
                  [disabled]="row.message"
                  (click)="smsChange(row)"
                >
                  <mat-icon>message</mat-icon>
                </mat-button-toggle>
                <!-- <mat-button-toggle value="portalType" aria-label="Text align right" [disabled]="row.portal"
                  (click)="portChange(row)">
                  <img *ngIf="!row.portal" alt="portal_icon" title="Portal"
                    src="./assets/images/portal_notification.svg" height="20px" />
                  <img *ngIf="row.portal" alt="portal_icon" title="Portal"
                    src="./assets/images/portal_notification_disabled.svg" height="20px" />
                </mat-button-toggle> -->
              </mat-button-toggle-group>
              <!-- <button
                mat-button
                title="Mail"
                [disabled]="row.mail"
                (click)="mailChange(row)"
              >
                <mat-icon>mail</mat-icon>
              </button>
              <button
                mat-button
                title="Notification"
                [disabled]="row.notify"
                (click)="internalChange(row)"
              >
                <mat-icon>notifications</mat-icon>
              </button>
              <button
                mat-button
                title="Message"
                [disabled]="row.message"
                (click)="smsChange(row)"
              >
                <mat-icon> message</mat-icon>
              </button> -->
            </div>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
      <div class="row">
        <div class="col-md-4">
          <mat-button-toggle-group
            #group2="matButtonToggleGroup"
            [value]="internalType"
          >
            <mat-button-toggle value="internalType" aria-label="notifications">
              <mat-icon>notifications</mat-icon>
            </mat-button-toggle>
            <p class="help-block">
              Status enabled,<br />
              can be overridden.
            </p>
          </mat-button-toggle-group>
        </div>
        <div class="col-md-4">
          <mat-button-toggle-group
            #group3="matButtonToggleGroup"
            [value]="internalType"
          >
            <mat-button-toggle value="internalType" aria-label="notifications">
              <mat-icon style="margin-top: 10px">notifications</mat-icon>
            </mat-button-toggle>
            <p class="help-block">
              Status disabled,<br />
              can be overridden.
            </p>
          </mat-button-toggle-group>
        </div>
        <!--  <div class="col-md-0.5">
          <mat-icon style="margin-top: 10px">notifications</mat-icon>
        </div>
        <div class="col-md-3">
          <p class="help-block">
            Status disabled,<br />
            can be overridden.
          </p>
        </div> -->
        <div class="col-md-4">
          <mat-button-toggle-group
            #group4="matButtonToggleGroup"
            [value]="internalType"
          >
            <mat-button-toggle
              value="internalType3"
              aria-label="notifications"
              [disabled]="true"
            >
              <mat-icon>notifications</mat-icon>
            </mat-button-toggle>
            <p class="help-block">
              Status disabled,<br />
              cannot be overridden.
            </p>
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
  </div>
</div>
